import {
  type UploadFileWithId,
  createSingleUploadModel,
} from '@/features/upload-files'
import { sample } from 'effector'

import {
  changeCurrentFeedbackInput,
  feedbackChatMessageSubmit,
} from './feedback-chat.model'

const uploadModel = createSingleUploadModel()

export const { $file, fileAdded, fileRemoved, fileInit, Gate } = uploadModel

sample({
  clock: $file,
  filter: (store: {
    file: UploadFileWithId | null
  }): store is { file: UploadFileWithId } => store.file?.status === 'done',
  fn: ({ file }) => ({
    attachmentId: file.id,
  }),
  target: [changeCurrentFeedbackInput, feedbackChatMessageSubmit],
})

export const $fileSubmiting = $file.map(({ file }) =>
  file ? file.status !== 'done' : false,
)
